import { postApi } from "../components/Utility";
import { action, makeObservable, observable } from "mobx";
import config from "../config";

class AIDashboardStore {
  total = 0;
  vidle = 0;
  vmove = 0;
  vnodata = 0;
  vstop = 0;
  alarmData = [];
  statuses = [];

  loading = false;
  counts = [];
  vehPer = [];
  jobState = [];
  fleetHours = 0;
  fuelWastage = 0;
  dayHours = 0;
  totalWorkingHrs = 0;
  nightHours = 0;
  dueCount = 0;
  overDue = 0;
  reminderDueCount = 0;
  reminderOverDue = 0;
  workinghour = [];
  MaxSpeedGraph = [];
  distanceTravelled = 0;
  avgDistperVeh = 0;
  vehicleScore = [];
  totalvehstate = [];
  MaxSpeedBars = "";
  fleetStatusArr = [];
  alertTrend = [];
  deviceAlarmGraph = [];
  dashboardCount = [];
  driverData = [];
  rootStore;

  constructor(rootStore) {
    makeObservable(this, {
      loading: observable,
      counts: observable,
      vidle: observable,
      vmove: observable,
      vnodata: observable,
      vstop: observable,
      alarmData: observable,
      statuses: observable,

      vehPer: observable,
      jobState: observable,
      fleetHours: observable,
      fuelWastage: observable,
      dueCount: observable,
      overDue: observable,
      reminderDueCount: observable,
      reminderOverDue: observable,
      workinghour: observable,
      MaxSpeedGraph: observable,
      distanceTravelled: observable,
      avgDistperVeh: observable,
      vehicleScore: observable,
      totalvehstate: observable,
      MaxSpeedBars: observable,
      fleetStatusArr: observable,
      dashboardCount: observable,
      deviceAlarmGraph: observable,
      alertTrend: observable,
      driverData: observable,
      loadData: action,
      getGraphData: action,
    });
    this.rootStore = rootStore;
  }

  async loadData({
    companyId,
    userId,
    isadmin,
    filterValue,
    fromDate,
    toDate,
    date,
  }) {
    var postData = {
      companyId: companyId,
      userId: userId,
      isadmin: isadmin,
      filterValue: filterValue,
      fromDate: fromDate,
      toDate: toDate,
      date: date,
    };
    // this.loading = true;
    var response = await postApi
      .getClient()
      .get(config.NodeUrl + "/aiDashboard/getAiDashboardCount", {
        params: postData,
      });

    this.dashboardCount = response?.data?.data;
    this.loading = false;

    var response2 = await postApi
      .getClient()
      .get(config.NodeUrl + "/aiDashboard/aiDeviceStatus", {
        params: postData,
      });

    this.vidle = response2.data.data.vidle;
    this.vmove = response2.data.data.vmove;
    this.vnodata = response2.data.data.vnodata;
    this.vstop = response2.data.data.vstop;
    this.statuses = [
      { label: "Stopped", color: "#f44336", count: response2.data.data.vstop },
      { label: "Idling", color: "#ffc107", count: response2.data.data.vidle },
      { label: "Running", color: "#4caf50", count: response2.data.data.vmove },
      {
        label: "Offline",
        color: "#000000",
        count: response2.data.data.vnodata,
      },
    ];

    var response4 = await postApi
      .getClient()
      .get(config.NodeUrl + "/aiDashboard/getAlarmCount", {
        params: postData,
      });
    this.alarmData = response4.data.data.result;

    var response5 = await postApi
      .getClient()
      .get(config.NodeUrl + "/aiDashboard/getAiDriverCount", {
        params: postData,
      });
    this.driverData = response5.data.data.result;
  }

  async getGraphData({
    companyId,
    userId,
    isadmin,
    filterValue,
    fromDate,
    toDate,
    date,
  }) {
    var postData = {
      companyId: companyId,
      userId: userId,
      isadmin: isadmin,
      filterValue: filterValue,
      fromDate: fromDate,
      toDate: toDate,
      date: date,
    };

    var graphPostData = {
      companyId: companyId,
      type: "maxspeed",
      isadmin: isadmin,
      userId: userId,
      aiDashboard: 1,
      fromDate: fromDate,
      toDate: toDate,
    };

    // var response = await postApi
    //   .getClient("NodeCoreUrl")
    //   .get("/aiDashboard/maxSpeedGraphDashboard", {
    //     params: postData,
    //   });

    var response = await postApi
      .getClient()
      .get(config.NodeUrl + "/aiDashboard/deviceAlarmGraph", {
        params: postData,
      });

    this.deviceAlarmGraph = response.data.data.result;

    var alarmResponse = await postApi
      .getClient()
      .get(config.NodeUrl + "/aiDashboard/getAlertTrend", {
        params: postData,
      });

    let alertData = alarmResponse?.data?.data;

    const aiCount = alertData.aiCount || {};
    const normalCount = alertData.normalCount || {};

    const chartData = Object.keys(aiCount).map((key) => ({
      name: key,
      AI: aiCount[key],
      Normal: normalCount[key] ?? 0,
    }));

    this.alertTrend = chartData;

    var maxspeedGraphResponse = await postApi
      .getClient()
      .get(config.NodeUrl + "/advanceDashboard/maxSpeedGraph", {
        params: graphPostData,
      });

    this.MaxSpeedGraph = maxspeedGraphResponse.data.data?.MaxSpeedGraph;
  }
}

export default AIDashboardStore;
